module.exports = __webpack_public_path__ + "img/Kibe57.ccfa4d57.jpg";